import {Feature} from 'acng/core/model/feature';
import {PopupElement} from '@acng/frontend-discovery';

const name = 'layout';
export default name;
export const layoutFeature = new Feature(name, false);

layoutFeature.defineElement('onsw-popup', PopupElement);
